import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";

import { StoreLogsModule } from "./StoreLogs";

const StoreLogs = (props) => {
  const { notifications } = props;

  return (
    <ErrorBoundary moduleName="storeLogs" {...notifications}>
      <StoreLogsModule />
    </ErrorBoundary>
  );
};

export default StoreLogs;
